// extracted by mini-css-extract-plugin
module.exports = {"na":"acceptance_rate_na__VHsUV"};